export enum CookieKeys {
  KONZI_JWT_TOKEN = 'KONZI_JWT_TOKEN'
}
